'use strict';

var enableOptionalGDPR = function() {
    if($('#dwfrm_profile_customer_addtoemaillist').length > 0) {
        $('#dwfrm_profile_customer_addtoemaillist').click(function (e) {
            if($(this).is(':checked')) {
                document.getElementById('dwfrm_profile_account_consentpref').removeAttribute('disabled');
            } else {
                $('#dwfrm_profile_account_consentpref').removeAttr('checked');
                document.getElementById('dwfrm_profile_account_consentpref').disabled=true;
            }
        });
    }
}

var optionalGDPR = {
    init: function() {
        enableOptionalGDPR();
    }
}

export default optionalGDPR;
